import { render, staticRenderFns } from "./ArticleHero.vue?vue&type=template&id=b95f615e&"
import script from "./ArticleHero.vue?vue&type=script&lang=js&"
export * from "./ArticleHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumbNew: require('/opt/build/repo/components/UI/BreadcrumbNew.vue').default})
